exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline-field[data-v-a3fd64c4]{display:flex;gap:12px;max-width:640px}.field-help[data-v-a3fd64c4]{margin-top:4px;color:var(--text-muted);font-size:12px;line-height:18px}.content-blocks[data-v-a3fd64c4]{margin-top:32px;padding-top:24px;border-top:1px solid var(--border)}.content-blocks__heading[data-v-a3fd64c4]{display:flex;align-items:center;justify-content:space-between;max-width:820px}.content-blocks__heading .section-title[data-v-a3fd64c4]{margin:0}.rich-text[data-v-a3fd64c4]{width:100%}.rich-text[data-v-a3fd64c4] .ck-editor__editable{min-height:320px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a3fd64c4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/site-content/Information.vue
// module id = 605
// module chunks = 0